// Single-page export (SPE) guard for configurator sheets.
//
// Every generated PDF carries a plain URL link over each sheet's export icon
// (`${api}/spe/<project>/<s3Key>/<sheetId>`, added by pdf-generator's
// PostProcessing). On a configurator sheet (WF Enterprise page 4) that link
// carries no product selection: the selection only exists as Acrobat form
// state, and only the configurator's own JavaScript button serialises it
// (`/spe/.../k?cache_key=d0=…`). In viewers without PDF JavaScript the plain
// link is what a click reaches, and link scanners extract it from the file,
// so the frontend receives `/<project>/<s3Key>/page-4?generate=1` with
// nothing to configure from. Exporting that yields a blank, unconfigured
// configurator page (seen 2026-10-04 on the test pipeline).
//
// This helper recognises such a sheet from the HTML the SPE endpoint returns,
// so the renderer can show a message instead of generating.

// Rendered only by the configurator module's filter dropdowns
// (src/projects/_modular/pages/modules/config-tool/index.js).
const CONFIGURATOR_MARKER = /data-field-type=["']content_dropdown["']/;

export function sheetRequiresConfiguration(html) {
  if (typeof html !== "string" || html === "") return false;
  return CONFIGURATOR_MARKER.test(html);
}

// Snackbar text when generation is withheld. The rendered sheet is a static
// snapshot (its dropdowns do nothing) and the live tool is not offered to
// PDF recipients, so the only answer is: configure inside the PDF.
export const CONFIGURATION_REQUIRED_MESSAGE =
  "Nothing to export. Please configure in the PDF first.";
